<template>
    <div class="hiddend">
        <Header :selected="selected" :changeType="changeType" />
        <Detail :friendEnvPoster="friendEnvPoster" :friendPoster="friendPoster" :selected="selected"/>
      <go-back-home/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '../userPosterElement/Header'
import Detail from '../userPosterElement/Detail'

export default {
  name: 'Poster',
  meta:{page:true},
  created() {
      this.$store.dispatch('user/getFriendEnvPoster');
      this.$store.dispatch('user/getFriendPoster');
  },
  computed: {
        ...mapGetters('user', {
            friendEnvPoster: 'getFriendEnvPoster',
            friendPoster: 'getFriendPoster'
        })
  },
  methods:  {
      changeType: function (value) {
          this.selected = value;
      }
  },
  data() {
        return {
            selected: this.$route.query.selected == undefined ? '1' : this.$route.query.selected,
        }
  },
  components: {
      Header,
      Detail
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hiddend {
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Poster.vue